<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">2024. © Millenium horizon.</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">
            Millenium HS & Develop by Gaston.Dev
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HeaderLayout",
};
</script>
